import { render, staticRenderFns } from "./insurer.vue?vue&type=template&id=451b59ba&scoped=true&"
import script from "./insurer.vue?vue&type=script&lang=js&"
export * from "./insurer.vue?vue&type=script&lang=js&"
import style0 from "./insurer.vue?vue&type=style&index=0&id=451b59ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b59ba",
  null
  
)

export default component.exports